<template>
  <div class="material-table">
    <div class="material-table__actions mb15">
      <a-input-search
        v-model:value="keyword"
        enter-button
        class="w300"
        placeholder="请输入材料名称关键字"
        @search="search"
      >
      </a-input-search>
      <a-button type="primary" @click="add">加入待选 >></a-button>
    </div>
    <table-wrapper
      :data-config="{ format: dataFormat }"
      @onTableChange="onTableChange"
      :pagination="pagination"
      :loading="loading"
      :row-key="'materialId'"
      size="small"
      ref="tableRef"
      :bordered="true"
      :data-source="data"
      :columns="columns"
      @onSelectionChange="onSelectionChange"
      :tableHeight="tableHeight"
    >
      <template #budgetPrice="{ record }">
        {{ $filters.formatMoney(record.budgetPrice) }}元
      </template>
    </table-wrapper>
  </div>
</template>

<script lang="ts">
import _ from "lodash";
import { defineComponent, onMounted, reactive, toRefs, watch, PropType } from "vue";
import { ApplyService } from "@/views/purchase/apply/apply.service";
import { MaterialPageReq, MaterialRecord } from "@/views/purchase/apply/apply.interface";
import { columns } from "./constant";

export default defineComponent({
  name: "MaterialTable",
  props: {
    applyId: { type: String, default: "" },
    tableHeight:{
      type:Number,
      default:200
    },
    value: { type: Array as PropType<MaterialRecord[]>, default: [] },
  },
  emits: ["update:value"],
  setup(props, { emit }) {
    const state = reactive<{
      keyword: string;
      selectedIds: string[];
      selectedRows: MaterialRecord[];
      selectedList: any[];
      columns: any[];
    }>({
      keyword: "",
      selectedIds: [],
      selectedRows: [],
      selectedList: [],
      columns,
    });

    const queryReq = new MaterialPageReq(props.applyId);
    const queryRef = reactive(queryReq);

    const { data, loading, run, pagination } = ApplyService.useMaterialPageApi();

    const search = async () => {
      queryRef.current = 1;
      queryRef.materialName = state.keyword;
      await run(queryRef);
    };

    const onTableChange = async (pagination) => {
      queryRef.current = pagination.current;
      queryRef.size = pagination.pageSize;
      await run(queryRef);
    };

    const onSelectionChange = ({ ids, selectedRows }) => {
      state.selectedIds = ids;
      state.selectedRows = selectedRows;
    };
    const dataFormat = (rows) => {
      let ids = rows.reduce((pre, cur) => {
        pre.push(cur.id);
        return pre;
      }, []);
      return {
        ids,
        selectedRows: rows,
      };
    };
    const add = () => {
      const newValue = [...props.value, ...state.selectedRows];
      emit("update:value", _.uniqBy(newValue, "id"));
    };

    onMounted(async () => {
      await run(queryReq);
    });

    watch(
      () => props.value,
      async (newVal) => {
        const ids = (newVal || []).map((item) => item.materialId);
        state.selectedIds = ids;
      },
      { immediate: true }
    );

    return {
      ...toRefs(state),
      loading,
      data,
      pagination,
      search,
      onTableChange,
      onSelectionChange,
      add,
      dataFormat,
    };
  },
});
</script>

<style lang="less" scoped>
.material-table {
  &__actions {
    display: flex;
    justify-content: space-between;
  }
}
</style>
